import { render, staticRenderFns } from "./ActivateInstagramAlert.vue?vue&type=template&id=cd8c26ec"
import script from "./ActivateInstagramAlert.vue?vue&type=script&lang=js"
export * from "./ActivateInstagramAlert.vue?vue&type=script&lang=js"
import style0 from "./ActivateInstagramAlert.vue?vue&type=style&index=0&id=cd8c26ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports